import { Link } from 'react-router-dom'
import { FOOTER_LINKS, SITE } from '../data/site'
import './Footer.css'

export function Footer() {
  return (
    <footer className="site-footer">
      <div className="container site-footer__grid">
        <div>
          <Link to="/" className="site-footer__logo" aria-label={`${SITE.nameTa} முகப்பு`}>
            <img src={SITE.logoFull} alt="" width="88" height="88" />
          </Link>
          <p className="site-footer__brand">{SITE.nameTa}</p>
          <p className="site-footer__tag">{SITE.taglineTa}</p>
          <a className="site-footer__yt" href={SITE.youtubeUrl} target="_blank" rel="noopener noreferrer">
            YouTube — @{SITE.nameEn.replace(/\s/g, '').toLowerCase()}
          </a>
        </div>
        <div>
          <h2 className="site-footer__heading">தகவல்</h2>
          <ul>
            {FOOTER_LINKS.map((link) => (
              <li key={link.path}>
                <Link to={link.path}>{link.labelTa}</Link>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <h2 className="site-footer__heading">தொடர்பு</h2>
          <p>
            <a href={`mailto:${SITE.email}`}>{SITE.email}</a>
          </p>
          <p className="site-footer__small">{SITE.usageNotice}</p>
        </div>
      </div>
      <div className="container site-footer__bottom">
        <p>© {new Date().getFullYear()} {SITE.nameEn}. All rights reserved.</p>
        <p>{SITE.domain}</p>
      </div>
    </footer>
  )
}
